export default __webpack_public_path__ + "static/media/HTML-5.7262107a.svg";